import { useEffect } from 'react'
import { CircularProgress } from '@mui/material'
import { useGetIdsUsersCurrentHealthcareservices } from '@toktokdoctech/tokapi-client'
import RouterOutsideContainer from 'apps/ids/src/app/routers/RouterOutsideContainer'
import RouterError from 'apps/ids/src/app/routers/RouterError'
import { useSelectHcs } from './useSelectHcs'
import { HcsFromUrlSelectorProps } from './types'

export const HcsFromUrlSelector = ({ hcsId }: HcsFromUrlSelectorProps) => {
    const selectHcs = useSelectHcs()
    const {
        data: userHealthCareServices,
        isLoading,
        error,
    } = useGetIdsUsersCurrentHealthcareservices({
        query: { staleTime: 5000 },
    })

    const hasAccess = !!userHealthCareServices?.some((hcs) => hcs.id === hcsId)

    useEffect(() => {
        if (hasAccess) selectHcs(hcsId)
    }, [hasAccess, hcsId, selectHcs])

    if (error || (!isLoading && !hasAccess)) return <RouterError />

    return (
        <RouterOutsideContainer>
            <CircularProgress size="3.6rem" />
        </RouterOutsideContainer>
    )
}
